export default {
  'incomingWireDetail.wireDetail': 'Wire Detail',
  'incomingWireDetail.label.wiresFor': 'Wires For',
  'incomingWireDetail.columns.customerReference': 'Cust Reference',
  'incomingWireDetail.wireDetail.valueDate': 'Value Date',
  'incomingWireDetail.wireDetail.generalObi': 'General OBI',
  'incomingWireDetail.wireDetail.receiverFiInfo': 'Receiver FI Info',
  'incomingWireDetail.wireDetail.sendingBank': 'Sending Bank',
  'incomingWireDetail.wireDetail.viewDetail': 'View Detail'
};
